import { LAYOUTS, } from "@voltmoney/types";
import { WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
import { doneAction, goBackAction, needHelpAction } from "./actions";
import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import SharedPropsService from "../../SharedPropsService";
import { getDateMonthYearFromEpoch } from "../../configs/utils";
export const template = (height, getPendingCreditRequestResponse, stepperData, fromRouteId, pledgeDetails) => ({
    layout: {
        id: ROUTE.PRE_DASHBOARD_SCREEN,
        type: LAYOUTS.LIST,
        widgets: [
            {
                id: "preDashboardScreen",
                type: WIDGET.PRE_DASHBOARD_SCREEN,
            },
        ],
    },
    datastore: {
        preDashboardScreen: {
            height: height,
            goBackAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.PRE_DASHBOARD_SCREEN,
                payload: {
                    value: fromRouteId
                }
            },
            needHelpAction: {
                type: ACTION.NEED_HELP,
                routeId: ROUTE.PRE_DASHBOARD_SCREEN,
                payload: {}
            },
            getPendingCreditRequestResponse: pledgeDetails ? pledgeDetails : getPendingCreditRequestResponse,
            stepperData: stepperData,
            doneAction: {
                type: ACTION.DONE_ACTION,
                routeId: ROUTE.PRE_DASHBOARD_SCREEN,
                payload: {
                    value: fromRouteId
                }
            }
        }
    },
});
export const preDashboardScreenMF = {
    onLoad: async ({ getHeight, network, ...props }, { fromRouteId, pledgeDetails }) => {
        const userData = await SharedPropsService.getUser();
        let getPendingCreditRequestResponse;
        const creditId = userData?.linkedCredits[0]?.creditId;
        getPendingCreditRequestResponse = await network.get(`${api.getPendingCreditRequest}${creditId}?creditRequestTypes=ENHANCE_LIMIT_REQUEST`, {
            headers: await getAppHeader(),
        });
        let date = '';
        const placedOnDateFromBackend = pledgeDetails?.createdOn ? pledgeDetails?.createdOn : getPendingCreditRequestResponse?.data?.enhanceLimitRequestDetailsList[0]?.createdOn;
        const successDateFromBackend = pledgeDetails?.updatedOn ? pledgeDetails?.updatedOn : getPendingCreditRequestResponse?.data?.enhanceLimitRequestDetailsList[0]?.updatedOn;
        const newDate = new Date(placedOnDateFromBackend);
        const newSuccessDate = new Date(successDateFromBackend);
        const dateMonthYear = getDateMonthYearFromEpoch(placedOnDateFromBackend);
        let updatedDateMonthYear;
        let successDateMonthYear;
        if (dateMonthYear.includes(',')) {
            updatedDateMonthYear = dateMonthYear.replace(/,/g, '');
        }
        const successDate = getDateMonthYearFromEpoch(successDateFromBackend);
        if (dateMonthYear.includes(',')) {
            successDateMonthYear = successDate.replace(/,/g, '');
        }
        const options = {
            timeZone: 'Asia/Calcutta',
            hour12: true,
            hour: 'numeric',
            minute: 'numeric',
        };
        //@ts-ignore
        const istTime = newDate.toLocaleString('en-US', options);
        //@ts-ignore
        const successiSTTime = newSuccessDate.toLocaleString('en-US', options);
        date = `${istTime}, ${updatedDateMonthYear}`;
        const successDateAndTime = `${successiSTTime}, ${successDateMonthYear}`;
        const stepperData = [
            {
                "status": "COMPLETED",
                "verticalDisplayName": "Request placed successfully",
                "verticalDescription": `Placed on ${date}`,
                "order": 0
            },
            {
                "status": pledgeDetails?.status === "SUCCESS" ? "COMPLETED" : "IN_PROGRESS",
                "verticalDisplayName": pledgeDetails?.status === "SUCCESS" ? "Request processed" : "We’re processing your request",
                "verticalDescription": pledgeDetails?.status === "SUCCESS" ? `Processed on ${successDateAndTime}` : "It may take upto 2-3 business hours",
                "order": 1
            },
        ];
        return Promise.resolve(template(getHeight(), getPendingCreditRequestResponse.data.enhanceLimitRequestDetailsList[0], stepperData, fromRouteId, pledgeDetails));
    },
    actions: {
        [ACTION.GO_BACK]: goBackAction,
        [ACTION.NEED_HELP]: needHelpAction,
        [ACTION.DONE_ACTION]: doneAction,
    },
    clearPrevious: true,
};
